/**
 * Created by zhqmac on 2018/5/13.
 */
var MemoryModel = function (obj) {
    if (obj) {
        //类型
        this.type = obj.type;
        //值 数字
        this.text = obj.text;
    } else {
        //类型
        this.type = "";
        //值 数字
        this.text = "0";
    }
};

MemoryModel.prototype = {
    toString: function () {
        var result = `<memory type="{0}" text="{1}" />`;
        result = result.format(this.type,this.text);
        return result;
    }
};
export default MemoryModel;